export const classNames = (object) => Object.entries(object).filter(([, value]) => value).map(([key]) => key).join(' ');

export const textEllipsis = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const dataGridMobileStyles = ({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    '.DnkDataGrid-row + .DnkDataGrid-row:before': {
      background: 'transparent !important',
    },
    '.DnkDataGrid-cell': {
      padding: '0 !important',
    },
    '.DnkDataGrid-row.Mui-hovered': {
      backgroundColor: 'transparent !important',
    },
    '.DnkDataGrid-row:hover': {
      backgroundColor: 'transparent !important',
    },
    '.DnkDataGrid-filler > div': {
      borderTop: 'none',
    },
  },
});
